import { useReportPreferences } from '@/contexts/ReportPreferencesContext'
import { cn } from '@/lib/utils'

/**
 * @param {{ reportKey: string, name: string, category: string, children: import('react').ReactNode }} props
 */
export function ReportSection({ reportKey, name, category, children }) {
  const { isReportVisible } = useReportPreferences()

  if (!isReportVisible(reportKey, { name, category })) {
    return null
  }

  return (
    <section id={`report-${reportKey}`} className="scroll-mt-28">
      {children}
    </section>
  )
}
